import {Component, EventEmitter, Input, Output} from '@angular/core';


// Todo: In future will be replaced with MatIconType enum
export enum DisplayIcon {
  ExternalIcon = 'open_in_new',
  DialogIcon = 'article',
  CommentIcon = 'comment',
}

@Component({
  selector: 'app-open-link-as',
  templateUrl: './open-link-as.component.html',
  styleUrls: [
    '../../../../../styles/global/_management-styles.scss'
  ],
})
export class OpenLinkAsComponent {
  readonly Icon = DisplayIcon;

  @Input() text: string;
  @Input() url: string;
  @Input() icon: string = DisplayIcon.ExternalIcon;
  @Input() customTooltip?: string;
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  onClickAnchor($event: MouseEvent) {
    this.onClick.emit($event);
  }

  getTooltip(): string {
    if (this.customTooltip) {
      return this.customTooltip;
    }
    return this.icon !== this.Icon.ExternalIcon ? 'OPEN in Dialog' : 'OPEN in new tab';
  }
}